import { version } from '../version.json';
export function loadBundle(bundleName) {
    var min = getIsMinified() ? '.min' : '';
    var baseUrl = version === '1.0.0'
        ? 'http://localhost:3898'
        : "https://static.parastorage.com/unpkg/@wix/debug-panel@" + version + "/dist/statics/";
    var script = baseUrl + "/" + bundleName + ".bundle" + min + ".js";
    return loadScript(script);
}
function loadScript(src) {
    var script = document.createElement('script');
    return new Promise(function (resolve, reject) {
        script.onerror = function () { return reject(new Error("Could not load " + src)); };
        script.onload = function () { return resolve(window.DebugPanel); };
        script.src = src;
        document.body.append(script);
    }).finally(function () {
        script.remove();
    });
}
function getIsMinified() {
    try {
        var isMimified = process.env.IS_MINIFIED;
        return typeof isMimified === 'boolean' ? isMimified : true;
    }
    catch (ex) {
        return true;
    }
}
//# sourceMappingURL=loadBundle.js.map